import { getPortalApiBackendUrl } from '../getPortalApiBackendUrl'

function normalizePortalApiOverride(raw: string | undefined): string | null {
  const value = (raw ?? '').trim()
  if (!value) return null

  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value.replace(/\/$/, '')
  }

  if (/^(localhost|127\.0\.0\.1)(:\d+)?(\/.*)?$/.test(value)) {
    return `http://${value}`.replace(/\/$/, '')
  }

  return null
}

/**
 * Base URL for Portal API. When NEXT_PUBLIC_PORTAL_API_URL is set (e.g. local dev),
 * the client talks to that URL directly and injects x-user-identity when it's localhost.
 * Otherwise the client uses the Next.js proxy at /api/pp-api so dev/staging/prod
 * go through the proxy (and auth-gateway where applicable).
 */
export function getPortalApiBaseUrl(): string {
  const override = normalizePortalApiOverride(process.env.NEXT_PUBLIC_PORTAL_API_URL)
  if (override) return override

  if (globalThis.window === undefined) return getPortalApiBackendUrl()

  return '/api/pp-api'
}

export function isLocalPortalApiBaseUrlValue(baseUrl: string): boolean {
  const value = baseUrl.trim()
  if (!value) return false

  try {
    const url = new URL(value)
    const host = url.hostname
    return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')
  } catch {
    return false
  }
}
